/* Slumera PDP extras: pill above price, ship-date box under buy buttons, note under real stock bar */
(function(){
  function tpl(id){var t=document.getElementById(id);return t?t.content.firstElementChild.cloneNode(true):null;}
  function shipDate(days,cutoff){
    var d=new Date(); if(d.getHours()>=cutoff) d.setDate(d.getDate()+1);
    while(d.getDay()===0||d.getDay()===6) d.setDate(d.getDate()+1);
    var n=days; while(n>0){d.setDate(d.getDate()+1); if(d.getDay()!==0&&d.getDay()!==6) n--;}
    var lang=document.documentElement.lang||'en';
    try{return d.toLocaleDateString(lang,{weekday:'short',month:'short',day:'numeric'});}catch(e){return d.toDateString();}
  }
  function run(){
    document.querySelectorAll('[data-dl-price]').forEach(function(p){
      var row=p.parentElement; if(!row||(row.previousElementSibling&&row.previousElementSibling.classList.contains('slm-pill'))) return;
      var el=tpl('slm-pill-tpl'); if(el) row.parentElement.insertBefore(el,row);
    });
    document.querySelectorAll('.dl-buynow, .dl-atc').forEach(function(b){
      var form=b.closest('form'); if(!form||form.querySelector('.slm-ship')) return;
      var anchor=form.querySelector('.dl-buynow')||b.parentElement;
      var el=tpl('slm-ship-tpl'); if(!el) return;
      var t=el.querySelector('.slm-ship-t');
      t.textContent=t.getAttribute('data-title').replace('{date}',shipDate(+el.dataset.days||0,+el.dataset.cutoff||24));
      anchor.insertAdjacentElement('afterend',el);
    });
    document.querySelectorAll('.dl-stock:not(.dl-demo-stock)').forEach(function(s){
      if(s.querySelector('.slm-stock-note')) return; var el=tpl('slm-stock-tpl'); if(el) s.appendChild(el);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  document.addEventListener('shopify:section:load',run);
})();
